import { BrowserRouter as Router, Route, Link, Routes } from "react-router-dom";
import axios from "axios";
import React, { useState } from "react";
import logo from "../img/logo.png";
import background from "../img/oficinas.jpeg";
import Cookies from "universal-cookie";
import md5 from "md5";
import Swal from "sweetalert2";
import Modal from "react-modal";
import CryptoJS from "crypto-js";

function Login() {
  const cookies = new Cookies();
  const [correo_Electronico, setPostCorreoElectronico] = useState("");
  const [contrasena, setPostContrasena] = useState("");
  const [mostrarModal, setMostrarModal] = useState(false);
  const [actualContrasena, setActualContrasena] = useState("");
  const [nuevaContrasena, setNuevaContrasena] = useState("");
  const [usuarioId, setUsuarioId] = useState(null);

  const secretKey = "clave_secreta_segura";
  const [loading, setLoading] = useState(false);
  const postData = async (e) => {
    e.preventDefault();

    setLoading(true);

    Swal.fire({
      title: "Iniciando sesión...",
      text: "Por favor espere",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      const body = {
        username: correo_Electronico,
        password: contrasena,
      };

      const response = await axios.post(
        "https://suadesarrollo.azurewebsites.net/api/AutenticaUsuarios",
        body,
        {
          auth: {
            username: "BasicAuth@icontec.org",
            password: "yQLzqmR7eZSuAmQZUqhY",
          },
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      );

      Swal.close();

      const valida = response.data;

      if (!valida || valida.length === 0) {
        Swal.fire("Error", "Usuario no válido", "error");
        return;
      }

      const respuesta = valida[0];

      cookies.set("ID", "%5B75%5D", { path: "/" });
      cookies.set("Nombre", respuesta.nombre, { path: "/" });
      cookies.set("correo", respuesta.correo_Electronico, { path: "/" });
      cookies.set("tipo_Usuario", respuesta.tipo_Usuario, { path: "/" });
      cookies.set("institucionid", respuesta.institucionId, { path: "/" });
      cookies.set(md5("Rol"), respuesta.rol, { path: "/" });
      cookies.set("terminos", respuesta.terminos, { path: "/" });
      cookies.set("primer_Ingreso", respuesta.primer_Ingreso, { path: "/" });

      setUsuarioId(respuesta.id);
      setActualContrasena(contrasena);

      if (respuesta.primer_Ingreso === 1) {
        setMostrarModal(true);
        return;
      }

      Swal.fire({
        title: "Bienvenido!",
        text: respuesta.nombre,
        icon: "success",
        timer: 2000,
        showConfirmButton: false,
      }).then(() => {
        redirigirSegunTipo(respuesta);
      });
    } catch (error) {
      Swal.close();

      console.error("Error en la autenticación", error);

      Swal.fire(
        "Error",
        "No fue posible iniciar sesión. Intente nuevamente.",
        "error",
      );
    } finally {
      setLoading(false);
    }
  };

  // ✅ FUNCIÓN LIMPIA Y CORRECTA
  const redirigirSegunTipo = (respuesta) => {
    const encryptedEmail = encodeURIComponent(
      CryptoJS.AES.encrypt(respuesta.correo_Electronico, secretKey).toString(),
    );

    let redirectUrl = "";

    if (respuesta.tipo_Usuario == 3) {
      redirectUrl = `/#/IndexEvaluador/${encryptedEmail}`;
    } else if (respuesta.tipo_Usuario == 6) {
      redirectUrl = `/#/SolicitudesDirector/${encryptedEmail}`;
    } else if (respuesta.tipo_Usuario == 4) {
      redirectUrl = `/#/SolicitudesJunta/${encryptedEmail}`;
    } else {
      redirectUrl = `/#/Home/${encryptedEmail}`;
    }

    if (respuesta.terminos === "Acepta") {
      window.location.href = redirectUrl;
    } else {
      Swal.fire({
        title: "Términos y Condiciones",
        text: "Por favor, acepte los términos y condiciones para continuar.",
        icon: "info",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.href = redirectUrl;
        } else {
          Swal.fire("Debe aceptar los términos y condiciones para continuar.");
        }
      });
    }
  };

  // 🔐 ACTUALIZAR CONTRASEÑA
  const actualizarContrasena = async () => {
    if (!actualContrasena || !nuevaContrasena) {
      Swal.fire("Error", "Ninguno de los campos debe estar vacío", "warning");
      return;
    }

    if (nuevaContrasena.length < 6) {
      Swal.fire(
        "Error",
        "La nueva contraseña debe tener al menos 6 caracteres",
        "warning",
      );
      return;
    }

    if (actualContrasena === nuevaContrasena) {
      Swal.fire(
        "Error",
        "La nueva contraseña no puede ser igual a la actual",
        "warning",
      );
      return;
    }

    try {
      const data = {
        Id: usuarioId,
        ActualContrasena: actualContrasena,
        NuevaContrasena: nuevaContrasena,
      };

      await axios.put(
        "https://suadesarrollo.azurewebsites.net/api/ActualizaUsuarios/ActualizaContrasenaUsuario",
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      Swal.fire("Éxito", "Contraseña actualizada correctamente", "success");

      setMostrarModal(false);

      // 🔁 Redirigir otra vez correctamente
      const encryptedEmail = encodeURIComponent(
        CryptoJS.AES.encrypt(correo_Electronico, secretKey).toString(),
      );

      let redirectUrl = "";

      if (cookies.get("tipo_Usuario") == 3) {
        redirectUrl = `/#/IndexEvaluador/${encryptedEmail}`;
      } else if (cookies.get("tipo_Usuario") == 4) {
        redirectUrl = `/#/SolicitudesJunta/${encryptedEmail}`;
      } else if (cookies.get("tipo_Usuario") == 6) {
        redirectUrl = `/#/SolicitudesDirector/${encryptedEmail}`;
      } else {
        redirectUrl = `/#/Home/${encryptedEmail}`;
      }

      window.location.href = redirectUrl;
    } catch (error) {
      Swal.fire("Error", "No se pudo actualizar la contraseña", "error");
      console.error(error);
    }
  };

  return (
    <div
      style={{
        backgroundImage: `url(${background})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        className="card shadow-lg"
        style={{
          width: "400px",
          padding: "20px",
          backgroundColor: "rgba(255,255,255,0.9)",
          borderRadius: "10px",
        }}
      >
        <div className="text-center">
          <img src={logo} width="130" alt="Logo" />
          <h4>Bienvenido a SUA</h4>
        </div>
        <a
          href="https://suadesarrollo.azurewebsites.net/api/AuthAzure"
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "10px",
            backgroundColor: "#2F2F2F",
            color: "white",
            padding: "12px 24px",
            borderRadius: "8px",
            textDecoration: "none",
            fontSize: "16px",
            fontWeight: "bold",
            boxShadow: "0px 4px 8px rgba(0,0,0,0.3)",
            transition: "transform 0.2s, box-shadow 0.2s",
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = "scale(1.05)";
            e.currentTarget.style.boxShadow = "0px 6px 12px rgba(0,0,0,0.4)";
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = "scale(1)";
            e.currentTarget.style.boxShadow = "0px 4px 8px rgba(0,0,0,0.3)";
          }}
        >
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg"
            alt="Microsoft"
            style={{ width: "24px", height: "24px" }}
          />
          Iniciar sesión con correo corporativo ICONTEC
        </a>
        <br></br>
        <form onSubmit={postData}>
          <input
            type="text"
            className="form-control mb-2"
            placeholder="Correo electrónico"
            onChange={(e) => setPostCorreoElectronico(e.target.value)}
          />
          <input
            type="password"
            className="form-control mb-2"
            placeholder="Contraseña"
            onChange={(e) => setPostContrasena(e.target.value)}
          />

          <button
            type="submit"
            className="btn btn-primary w-100"
            disabled={loading}
          >
            {loading ? "Iniciando sesión..." : "Iniciar Sesión"}
          </button>
        </form>

        <hr />
        <div className="text-center">
          <Link to={"/Recuperar"}>Olvidé mi contraseña</Link>
        </div>
      </div>

      <Modal isOpen={mostrarModal} ariaHideApp={false}>
        <h4>Actualizar Contraseña</h4>
        <input
          type="password"
          className="form-control mb-2"
          placeholder="Actual"
          value={actualContrasena}
          onChange={(e) => setActualContrasena(e.target.value)}
        />
        <input
          type="password"
          className="form-control mb-2"
          placeholder="Nueva"
          value={nuevaContrasena}
          onChange={(e) => setNuevaContrasena(e.target.value)}
        />
        <button className="btn btn-primary" onClick={actualizarContrasena}>
          Actualizar
        </button>
      </Modal>
    </div>
  );
}

export default Login;
